<template>
  <div style="background-color: #fafafa;">
    <van-nav-bar title="入库列表" left-text="返回" left-arrow @click-left="onClickLeft" :z-index=998 fixed />
    <van-tabs class="tabs" v-model="selected" type="line" sticky @click="switchTab">
      <van-tab title="待入库"/>
      <van-tab title="入库中"/>
      <van-tab title="已入库"/>
    </van-tabs>
    <van-search shape="round" v-model="value" placeholder="请填写入库单号搜索" show-action @search="onSearch"
                @cancel="onSearch">
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
        <div v-for="(inputData) in list" class="card" :key="inputData.uuid" @click="openDetail(inputData.uuid)">
          <table class="layout">
            <tr>
              <td colspan="2" class="content">
                <p>
                  <span>入库单号：</span>
                  <span>{{inputData.serialNumber || '无'}}</span>
                </p>
                <p>
                  <span>入库数量：</span>
                  <span>{{inputData.quantity || '无'}}</span>
                </p>
              </td>
            </tr>
          </table>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {Tab, Tabs, Panel, Button, List, Search, Popup,PullRefresh,Toast,NavBar,Tag,Col, Row ,Sidebar, SidebarItem,DatetimePicker,Field,DropdownMenu, DropdownItem, Icon} from 'vant';
import userInfo from '../../store/userInfo';
import electronicInputService from "../../service/electronicInputService";
import moment from "moment";
import {formatDictionary} from "../../utils/dictionary";
import {API_URL} from "../../common/config";

export default {
  data: function () {
    return {
      detailShow:false,
      selected: 0,
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      value: '',
      show: false,
      refreshing: false,
      type: 0,
      inputDataId:'',
      showTime: true,
      activeKey: 0,
      createTime: '',
      currDateType: 0,
      currCreateDateType: 0,
      currDisAdvisorDateType: 0,
    }
  },
  store: userInfo,
  components: {
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [NavBar.name]: NavBar,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [List.name]: List,
    [Col.name]: Col,
    [Row.name]: Row,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem .name]: DropdownItem,
    [Icon .name]: Icon
  },
  computed: {
    userId() {
      return this.$store.getters.getUserId;
    },
    avatarUrl() {
      return API_URL + "/oa/common/attachment/showImage?id=";
    }
  },
  created: async function () {
    let tabIndex = localStorage.getItem('inputDataTabIndex');
    if(tabIndex === undefined || tabIndex === null) {
      tabIndex = 0;
      this.selected = 0;
      this.type = 0;
    }else {
      this.selected = parseInt(tabIndex);
      this.type = parseInt(tabIndex);
    }
  },
  methods: {
    changeSideBar() {
      if(this.activeKey == 0) {
        this.currDateType = this.currCreateDateType
      }else {
        this.currDateType = this.currDisAdvisorDateType
      }
      this.showTime=false;
      var _this=this;
      this.$nextTick(function(){
        _this.showTime = true;
      })
    },
    async onLoad() {
      this.pageIndex++;
      let tabIndex = localStorage.getItem('inputDataTabIndex');
      if(tabIndex === undefined || tabIndex === null) {
        tabIndex = 0;
        this.type = 0;
      }else {
        this.type = parseInt(tabIndex);
      }
      let resp = await electronicInputService.getList(this.pageIndex, this.value, this.type);
      if (resp.data.Status == '1' && resp.data.Data.data.length > 0){
        resp.data.Data.data.forEach(item => {
          item.createTime = moment(item.createTime).format('YYYY-MM-DD');
        });
        formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      }
      this.loading = false;
      this.refreshing = false;
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
    },
    onSearch() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    onRefresh() {
      this.finished = false;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    openDetail(id){
      this.$router.push({path:"InputDetail/" + id})
    },
    async del(id,index,e){
      e.stopPropagation();
      let resp = await electronicInputService.del(id);
      if (resp.data.Status === '1') {
        Toast.success('操作成功');
        this.list.splice(index, 1);
      } else {
        Toast.fail(resp.data.Message);
      }
  },
    switchTab(tabIndex) {
      localStorage.setItem('inputDataTabIndex', tabIndex);
      window.scrollTo(0, 0);
      this.type = tabIndex;
      this.value = '';
      this.onSearch();
    },
    onClickLeft() {
      window.open('/colseWebView');
    },
  },
};

</script>

<style>
.dropdownItem>.van-dropdown-item>.van-popup {
  max-height: 100%;
  height: 100%;
}
.van-popup--right{
  width:100%;
  height:100%;
}
.van-nav-bar {
  z-index: 99999;
}
.tabs {
  margin-top: 120px;
}

.van-icon {
  margin-right: 0.6rem;
  color: #4090FA;
}

.icon {
  margin-left: 1rem;
}
</style>
